import CRUD from './crud'

export default new CRUD('telegram-messages', 'superior-judge')
